import { shellStringResources } from '../../Resources/ShellStringResources';
import { IAttribute } from '../base/annotation';
import { Metamodel } from '../base/model';
import { SalesforceV2Dataset } from '../dataset/salesforce-v2.dataset';
import { ModelConstants } from '../model-constants';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: ModelConstants.salesforceV2CopySource,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(SalesforceV2Dataset) }
})
export class SalesforceV2CopySource extends TabularCopySource {
    public static readonly INCLUDE_DELETED: IAttribute;
    public static readonly PARTITION_OPTION: IAttribute;
    public static readonly PAGESIZE: IAttribute;
    public static readonly PRESERVE_SCALE_FROM_SCHEMA: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.preserveScaleFromSchema,
        association: 'PRESERVE_SCALE_FROM_SCHEMA',
        templatable: true
    })
    public preserveScaleFromSchema?: boolean = false;

    @Metamodel.attribute({
        display: shellStringResources.includeDeletedObj,
        association: 'INCLUDE_DELETED',
        templatable: true
    })
    public includeDeletedObjects: boolean = false;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Partition_Option,
        association: 'PARTITION_OPTION',
        templatable: true
    })
    public partitionOption: string = 'AutoDetect';

    @Metamodel.attribute({
        templatable: true,
        association: 'PAGESIZE',
        display: shellStringResources.PageSizeLabel,
        constraint: {
            minimum: 1
        }
    })
    public pageSize?: number = 300000;

    // Madrid-only, to support existing SalesforceV2 copysource that used 'SOQLQuery' instead of 'query'
    public isSoqlQuery: boolean = false;
}
